import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PushNotificationRoutingModule } from './push-notification-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PushNotificationRoutingModule
  ]
})
export class PushNotificationModule { }
